<template>
    <b-card class="m-4">
        <template v-slot:header>
            <div class="text-right">
                <b-button variant="primary" :to="{ name: 'PublicationNew' }"><font-awesome-icon icon="plus"></font-awesome-icon> Nueva</b-button>
            </div>
        </template>

        <b-row class="mb-2">
            <b-col sm="5" md="6" class="my-1">
                <b-input-group size="sm" prepend="Mostrar" append="registros">
                    <b-form-select v-model="itemsPerPage" id="perPageSelect" size="sm" :options="pageOptions" style="max-width: 5em"></b-form-select>
                </b-input-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-input-group prepend="Filtrar: ">
                    <b-input v-model="filter" debounce="300"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row class="mb-2" v-if="localeData">
            <b-col sm="12" md="8" lg="6" class="my-1 text-left">
                <b-form-group label="Filtrar por fecha de publicación">
                    <date-range-picker opens="right" :locale-data="localeData" :append-to-body="true" :showWeekNumbers="false"
                                       v-model="dates" :autoApply="true" :linkedCalendars="true" :date-range="dates" :ranges="false"
                                       @update="updateDates">
                        <template v-slot:input style="min-width: 200px;" v-if="!startDate">
                            <span>Fecha inicio - Fecha fin</span>
                        </template>
                    </date-range-picker>
                    <span class="d-none ml-2 d-sm-inline-block"></span>
                    <b-button variant="success" @click="clearDatesInput" style="vertical-align: top;">
                        <font-awesome-icon icon="eraser"></font-awesome-icon> Limpiar
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <b-table :items="loadData" :fields="fields" :filter="filter" :current-page="currentPage" :per-page="itemsPerPage"
                 empty-text="Sin registros" empty-filtered-text="Sin coincidencias" :sort-by.sync="sortBy" class="text-left"
                 striped bordered hover small show-empty responsive ref="publicationsTable">
            <template v-slot:thead-top>
                <b-tr>
                    <b-th v-for="(field, index) in fields" :key="field.field">
                        <b-row>
                            <b-col v-if="filters[index]">
                                <b-input :placeholder="field.label" v-model="filters[index].value" debounce="300"></b-input>
                            </b-col>
                        </b-row>
                    </b-th>
                </b-tr>
            </template>

            <template v-slot:cell(groups)="row">
                <template v-for="group in row.item.groups">
                    <b-badge variant="primary" class="p-1 ml-1" :key="group.id">{{ group.name }}</b-badge>
                </template>
            </template>

            <template v-slot:cell(status)="row">
                <div class="text-center">
                    <b-badge variant="info" v-if="row.item.status === 'DRAFT'" class="p-1">Borrador</b-badge>
                    <b-badge variant="success" v-else>Publicado</b-badge>
                </div>
            </template>

            <template v-slot:cell(files)="row">
                {{ row.item.files.length }}
            </template>

            <template v-slot:cell(actions)="row">
                <div class="text-center">
                    <b-button-group size="sm">
                        <b-button :to="{ name: 'PublicationShow', params: { id: row.item.publicationId }}" v-b-tooltip.hover
                                  title="Detalle" variant="outline-primary">
                            <font-awesome-icon icon="search"></font-awesome-icon>
                        </b-button>
                        <b-button :to="{ name: 'PublicationEdit', params: { id: row.item.publicationId }}" v-b-tooltip.hover
                                  title="Modificar" variant="outline-primary">
                            <font-awesome-icon icon="edit"></font-awesome-icon>
                        </b-button>
                        <b-button v-b-tooltip.hover @click="row.toggleDetails" variant="outline-primary"
                                  :title="row.detailsShowing ? 'Ocultar archivos' : 'Ver archivos'">
                            <font-awesome-icon :icon="row.detailsShowing ? 'minus' : 'plus'"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                </div>
            </template>

            <template v-slot:row-details="row">
                <template v-if="row.item.files.length > 0">
                    <b-table :items="row.item.files" :fields="fileFields"
                             striped bordered hover small show-empty responsive style="font-size: .9rem;">
                        <template v-slot:cell(number)="fileRow">{{ fileRow.index + 1 }}</template>

                        <template v-slot:cell(size)="fileRow">{{ formatBytes(fileRow.item.size) }}</template>

                        <template v-slot:cell(actions)="fileRow">
                            <b-button-group>
                                <b-button v-b-tooltip.hover.auto @click="openFileLogsModal(fileRow.item)"
                                          variant="outline-primary" title="Ver historial" class="px-1 py-0">
                                    <font-awesome-icon icon="list"></font-awesome-icon>
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-table>
                </template>
                <div class="text-center" v-else> Sin archivos</div>
            </template>

            <template v-slot:table-caption>
                <b-row class="no-gutters">
                    <b-col sm="5" md="6">
                        Mostrando {{ start }} a {{ end }} de {{ totalRows }} registro<template v-if="totalRows !== 1">s</template>
                    </b-col>
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage"
                                      align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-table>

        <b-modal id="file-logs-modal" size="lg" title="Historial de descargas" ok-title="Cerrar" ok-only>
            <b-row no-gutters class="text-left">
                <b-col>
                    <b-table :items="fileLogs" :fields="fileLogsfields" empty-text="Sin registros" striped bordered hover small show-empty responsive>
                    </b-table>
                </b-col>
            </b-row>
        </b-modal>

<!--        <b-row>-->
<!--            <b-col offset-sm="5" offset-md="6" sm="7" md="6" class="my-1">-->
<!--                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>-->
<!--            </b-col>-->
<!--        </b-row>-->
    </b-card>
</template>

<script>
import { publicationItemsListUrl, fileLogsUrl } from '@routes';
import * as constants from '@constants';
import DateRangePicker from '@plugins/vue2-daterange-picker';

import '@plugins/vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
    props: {
        settings: Object,
        dateRangeFormat: String
    },
    data() {
        return {
            fields: [
                { key: 'folio', label: 'Folio', class: 'text-right pr-3', sortable: true },
                { key: 'created', label: 'Fecha de creación', sortable: true },
                { key: 'createdBy', label: 'Creado por', sortable: true },
                { key: 'customer', label: 'Cliente', sortable: true },
                { key: 'groups', label: 'Grupos' },
                { key: 'publicationDate', label: 'Fecha de publicación', sortable: true },
                { key: 'status', label: 'Estatus' },
                { key: 'files', label: 'Archivos', class: 'text-center' },
                { key: 'actions', label: 'Acciones' }
            ],
            filters: [
                { column: 'pi.folio', type: 'STRING', value: '', format: '' },
                { column: 'pi.created', type: 'DATETIME', value: '', format: '' },
                { column: 'u.name', type: 'STRING', value: '', format: '' },
                { column: 'c.legal_name', type: 'STRING', value: '', format: '' },
                null,
                { column: 'pi.publication_date', type: 'DATETIME', value: '', format: '' }
            ],
            filter: '',
            isLoading: false,
            pageOptions: [25, 50, 75, 100],
            totalRows: 0,
            currentPage: 1,
            itemsPerPage: 25,
            sortBy: 'pi.publication_date',
            sortDesc: false,
            localeData: null,
            dates: {
                startDate: null,
                endDate: null
            },
            fileFields: [
                { key: 'number', label: 'Número', class: 'text-right' },
                { key: 'name', label: 'Nombre' },
                { key: 'created', label: 'Fecha de carga' },
                { key: 'size', label: 'Tamaño', class: 'text-right' },
                { key: 'createdBy', label: 'Cargado por' },
                { key: 'downloadCount', label: 'Cantidad de descargas', class: 'text-right' },
                { key: 'actions', label: 'Acciones', class: 'text-center' }
            ],
            fileLogs: [],
            fileLogsfields: [
                { key: 'date', label: 'Fecha', sortable: false },
                { key: 'user', label: 'Usuario', sortable: false }
            ]
        }
    },
    components: {
        DateRangePicker
    },
    created() {
        this.$parent.loadData().then(() => {
            for (let i = this.settings.customFields.length - 1; i >= 0; i--) {
                let field = this.settings.customFields[i];

                if (field.enabled) {
                    this.fields.splice(3, 0, {
                        key: `field${i + 1}`,
                        label: field.name,
                        sortable: true
                    });

                    this.filters.splice(3, 0, {
                        column: `pi.field${i + 1}`,
                        type: field.type === 'TEXT' ? 'STRING' : 'DATE',
                        value: '',
                        format: ''
                    });
                }
            }

            this.localeData = {
                direction: 'ltr',
                format: this.dateRangeFormat,
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                weekLabel: 'S',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['D', 'L', 'M', 'Mi', 'J', 'V', 'S'],
                monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                firstDay: 0
            };
        });
    },
    methods: {
        loadData(ctx) {
            if (ctx.sortBy !== '') {
                let data = {
                    filters: this.filters.filter(filter => filter ? filter.value.trim() !== '' : false),
                    ...ctx
                };

                data.currentPage = (data.currentPage - 1) * data.perPage;
                data.dates = {
                    startDate: this.startDate,
                    endDate: this.endDate
                };

                return this.axios.post(publicationItemsListUrl(), data).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.totalRows = response.data.totalRows;
                        return response.data.publicationItems;
                    } else {
                        return [];
                    }
                }).catch(error => {
                    console.error(error);

                    return [];
                });
            }
        },
        clearDatesInput() {
            this.dates.startDate = null;
            this.dates.endDate = null;

            this.$refs.publicationsTable.refresh();
        },
        updateDates() {
            this.$refs.publicationsTable.refresh();
        },
        openFileLogsModal(file) {
            this.axios.get(fileLogsUrl(), {
                params: {
                    fileId: file.id,
                    action: 'DOWNLOAD'
                },
                responseType: 'json'
            }).then(response => {
                if (response.data.code === 'OK') {
                    this.fileLogs = response.data.logs;
                }
            });

            this.$bvModal.show('file-logs-modal');
        },
        formatBytes(size) {
            const ratio = 1024, digits = 2;
            let units = ['B', 'KB', 'MB', 'GB'];
            let unit = 0;

            size = parseInt(size);

            while (size > 1024) {
                size /= ratio;
                unit++;
            }

            return `${size.toFixed(digits)} ${units[unit]}`;
        }
    },
    computed: {
        startDate() {
            let date = '';

            if (this.dates.startDate) {
                date = `${this.dates.startDate.getFullYear()}-${(this.dates.startDate.getMonth() +1).toString().padStart(2, '0')}` +
                    `-${(this.dates.startDate.getDate()).toString().padStart(2, '0')}`;
            }

            return date;
        },
        endDate() {
            let date = '';

            if (this.dates.endDate) {
                date = `${this.dates.endDate.getFullYear()}-${(this.dates.endDate.getMonth() + 1).toString().padStart(2, '0')}` +
                    `-${(this.dates.endDate.getDate()).toString().padStart(2, '0')}`;
            }

            return date;
        },
        start: function() {
            return this.totalRows === 0 ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        end: function() {
            let offset = (this.currentPage - 1) * this.itemsPerPage;

            return (this.totalRows - offset) < this.itemsPerPage ? this.totalRows : offset + this.itemsPerPage;
        }
    },
    watch: {
        filters: {
            handler() {
                this.$refs.publicationsTable.refresh();
            },
            deep: true
        }
    }
}
</script>

<style>

</style>